import TextField from "@mui/material/TextField";
import { type FC } from "react";

export const ReadOnlyTextField: FC<{ label: string; value: string }> = ({ label, value }) => (
  <TextField label={label} value={value} variant="outlined" size="small" disabled />
);
